import { jwtDecode } from 'jwt-decode';
import { useMemo } from 'react';
import { useAuth } from './useAuth';

interface JwtAccessClaims {
  user_id: number;
  group_id: number | null;
  permissions: string[];
}

export interface JwtClaims {
  userId: number | undefined;
  groupId: number | null | undefined;
  permissions: string[];
}

const EMPTY_CLAIMS: JwtClaims = { userId: undefined, groupId: undefined, permissions: [] };

export const useJwtClaims = (): JwtClaims => {
  const {
    data: { accessToken },
  } = useAuth();

  return useMemo(() => {
    if (!accessToken) return EMPTY_CLAIMS;

    try {
      const { user_id, group_id, permissions } = jwtDecode<JwtAccessClaims>(accessToken);
      return { userId: user_id, groupId: group_id, permissions: permissions ?? [] };
    } catch {
      return EMPTY_CLAIMS;
    }
  }, [accessToken]);
};
